<div class="notice" [ngClass]="'notice--' + (data.tone ?? 'success')">
  <span class="notice__badge"
    ><mat-icon>{{ icon }}</mat-icon></span
  >
  <div class="notice__body">
    <div class="notice__title">{{ data.title }}</div>
    <div class="notice__text" *ngIf="data.text">
      {{ textBefore }}<strong *ngIf="highlighted">{{ data.highlight }}</strong
      >{{ textAfter }}
    </div>
  </div>
  <button
    type="button"
    class="notice__close"
    aria-label="Dismiss"
    (click)="snackBarRef.dismiss()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
